module.exports = __webpack_public_path__ + "static/ct.67515269.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ct.png
// module id = 460
// module chunks = 114276838955818